export function isCanadianPostalCode(code) {
  const re = /^[A-Za-z][0-9][A-Za-z] ?(?:[0-9][A-Za-z][0-9])?$/;
  return re.test(code);
}

export function isUSZipCode(code) {
  const re = /^[0-9]{5}$/;
  return re.test(code);
}

export function isValidPostalCode(code) {
  return !!code && (isCanadianPostalCode(code) || isUSZipCode(code));
}
